/**
  * 商城 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
//  const api = '/home/'
 const api = '/c-api/'
 
 const index = {
    // 收货地址列表
    addressList (params) {
        return axios.post('/home/b2c/addresslist', qs.stringify(params))
    },
    // 添加收货地址
    addAddress (params) {
        return axios.post('/home/b2c/addaddress', qs.stringify(params))
    },
    // 收货地址详情
    addressDetail (params) {
        return axios.post('/home/b2c/addressinfo', qs.stringify(params))
    },
    // 编辑收货地址
    editAddress (params) {
        return axios.post('/home/b2c/editaddress', qs.stringify(params))
    },
    // 删除收货地址
    deleteAddress (params) {
        return axios.post('/home/b2c/deladdress', qs.stringify(params))
    },
    // 区域信息
    areaList (params) {
        return axios.get('/home/area/list', { params: params })
    },
 }
 
 // 导出接口
 export default index